module.exports = __webpack_public_path__ + "img/Produktbeispiel_2.58c8bc23.jpg";